const initialized = new WeakSet();

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const SCENE_CONFIGS = {
  'naruto-simple': {
    background: 'naruto-simple',
    fog: 0x11182a,
    fogNear: 20,
    fogFar: 48,
    exposure: 1.1,
    cameraMultiplier: 1.54,
    minZoom: 0.72,
    maxZoom: 1.58,
    autoRotateSpeed: 0.003,
    materialBoost: 1.06,
    particles: 'soft-glow',
    hemi: [0xfff4d6, 0x111a2e, 1.55],
    key: [0xffbd62, 2.25, 2.7, 4.2, 3.2],
    fill: [0xb9d7ff, 0.82, -2.8, 1.8, 2.5],
    rim: [0x7ab7ff, 1.45, -3.1, 2.5, -3.2],
    point: [0xff9d32, 0.45, 0, 1.6, 2.8],
  },
  'naruto-action': {
    background: 'naruto-action',
    fog: 0x160b08,
    fogNear: 16,
    fogFar: 42,
    exposure: 1.16,
    cameraMultiplier: 1.46,
    minZoom: 0.68,
    maxZoom: 1.5,
    autoRotateSpeed: 0.0043,
    materialBoost: 1.08,
    particles: 'energy-streaks',
    hemi: [0xfff1d0, 0x101b2f, 1.62],
    key: [0xff9d2e, 2.95, 2.8, 4.2, 3.2],
    fill: [0x9ecbff, 0.72, -2.7, 1.6, 2.4],
    rim: [0x52a4ff, 2.15, -3.1, 2.6, -3.3],
    point: [0xff6b1a, 0.7, 1.4, 1.1, 2.4],
  },
  'sasuke-action': {
    background: 'sasuke-action',
    fog: 0x070713,
    fogNear: 14,
    fogFar: 38,
    exposure: 1.06,
    cameraMultiplier: 1.5,
    minZoom: 0.7,
    maxZoom: 1.54,
    autoRotateSpeed: 0.0034,
    materialBoost: 1.04,
    particles: 'electric-glow',
    hemi: [0xdfe7ff, 0x05040b, 1.22],
    key: [0x9db8ff, 2.15, 2.6, 4.1, 3.2],
    fill: [0x9983ff, 0.42, -2.5, 1.5, 2.3],
    rim: [0x7d5cff, 2.45, -3.2, 2.7, -3.3],
    point: [0x855cff, 0.62, -1.4, 1.5, 2.2],
  },
  madara: {
    background: 'madara',
    fog: 0x5b3434,
    fogNear: 24,
    fogFar: 64,
    exposure: 1.2,
    cameraMultiplier: 1.48,
    minZoom: 0.68,
    maxZoom: 1.52,
    autoRotateSpeed: 0.0035,
    materialBoost: 1.1,
    particles: 'neon-dust',
    hemi: [0xffefe3, 0x513036, 1.72],
    key: [0xffd2a6, 2.75, 2.7, 4.2, 3.2],
    fill: [0xd0bbff, 0.95, -2.7, 1.7, 2.4],
    rim: [0xff6c74, 1.55, -3.0, 2.7, -3.2],
    point: [0xffb36f, 0.42, 1.2, 1.4, 2.2],
  },
  luffy: {
    background: 'luffy',
    fog: 0xbed8e5,
    fogNear: 26,
    fogFar: 68,
    exposure: 1.22,
    cameraMultiplier: 1.5,
    minZoom: 0.7,
    maxZoom: 1.54,
    autoRotateSpeed: 0.0036,
    materialBoost: 1.11,
    particles: 'soft-glow',
    hemi: [0xfff5d8, 0x97cfe5, 1.95],
    key: [0xffd37a, 2.85, 2.8, 4.4, 3.3],
    fill: [0xd8f7ff, 1.18, -2.7, 1.7, 2.5],
    rim: [0x65cfff, 1.4, -3.1, 2.5, -3.2],
    point: [0xffe08a, 0.4, 0.8, 1.4, 2.4],
  },
  'nagato-pain': {
    background: 'nagato-pain',
    fog: 0x373046,
    fogNear: 24,
    fogFar: 62,
    exposure: 1.18,
    cameraMultiplier: 1.5,
    minZoom: 0.7,
    maxZoom: 1.54,
    autoRotateSpeed: 0.0032,
    materialBoost: 1.1,
    particles: 'electric-glow',
    hemi: [0xf2edff, 0x302a3c, 1.62],
    key: [0xe3d8ff, 2.55, 2.6, 4.1, 3.2],
    fill: [0xc0a9ff, 0.9, -2.6, 1.6, 2.4],
    rim: [0xffc07a, 1.35, -3.0, 2.5, -3.2],
    point: [0xc0a9ff, 0.42, -1.2, 1.4, 2.2],
  },
  obito: {
    background: 'obito',
    fog: 0x4a302a,
    fogNear: 24,
    fogFar: 64,
    exposure: 1.19,
    cameraMultiplier: 1.5,
    minZoom: 0.7,
    maxZoom: 1.54,
    autoRotateSpeed: 0.0033,
    materialBoost: 1.1,
    particles: 'energy-streaks',
    hemi: [0xffead8, 0x3b2938, 1.68],
    key: [0xffb06f, 2.7, 2.7, 4.2, 3.2],
    fill: [0xc8b2ff, 0.88, -2.7, 1.7, 2.4],
    rim: [0xff8552, 1.45, -3.0, 2.6, -3.2],
    point: [0xffa06a, 0.38, 1.0, 1.3, 2.2],
  },
  'premanand-maharaj': {
    background: 'premanand-maharaj',
    fog: 0xf2d7aa,
    fogNear: 28,
    fogFar: 72,
    exposure: 1.2,
    cameraMultiplier: 1.54,
    minZoom: 0.72,
    maxZoom: 1.58,
    autoRotateSpeed: 0.0025,
    materialBoost: 1.1,
    particles: 'soft-glow',
    hemi: [0xfff6df, 0xd6ad74, 1.95],
    key: [0xffdf9a, 2.7, 2.6, 4.4, 3.4],
    fill: [0xffeed0, 1.1, -2.7, 1.8, 2.5],
    rim: [0xf2c45f, 1.25, -3.0, 2.5, -3.2],
    point: [0xffdc8b, 0.3, 0, 2.1, 2.6],
  },
  gojo: {
    background: 'gojo',
    fog: 0xdde9f0,
    fogNear: 28,
    fogFar: 72,
    exposure: 1.2,
    cameraMultiplier: 1.52,
    minZoom: 0.7,
    maxZoom: 1.56,
    autoRotateSpeed: 0.003,
    materialBoost: 1.1,
    particles: 'soft-glow',
    hemi: [0xffffff, 0xc7dce6, 1.95],
    key: [0xffffff, 2.8, 2.7, 4.4, 3.4],
    fill: [0xbfeaff, 1.12, -2.7, 1.8, 2.5],
    rim: [0x91cfff, 1.2, -3.1, 2.5, -3.2],
    point: [0xffffff, 0.32, 0, 2.1, 2.6],
  },
  kakashi: {
    background: 'kakashi',
    fog: 0xd7e2df,
    fogNear: 28,
    fogFar: 72,
    exposure: 1.18,
    cameraMultiplier: 1.52,
    minZoom: 0.7,
    maxZoom: 1.56,
    autoRotateSpeed: 0.003,
    materialBoost: 1.1,
    particles: 'soft-glow',
    hemi: [0xffffff, 0xcbd8d1, 1.9],
    key: [0xf8fbff, 2.75, 2.7, 4.4, 3.4],
    fill: [0xd9f0e5, 1.08, -2.7, 1.8, 2.5],
    rim: [0x9bd3ff, 1.15, -3.1, 2.5, -3.2],
    point: [0xffffff, 0.3, 0, 2.1, 2.6],
  },
  joker: {
    background: 'joker',
    fog: 0x080308,
    fogNear: 16,
    fogFar: 42,
    exposure: 1.14,
    cameraMultiplier: 1.42,
    minZoom: 0.68,
    maxZoom: 1.5,
    autoRotateSpeed: 0.0032,
    materialBoost: 1.06,
    disableModelShadows: true,
    particles: 'neon-dust',
    hemi: [0xfff0d6, 0x0b0508, 1.58],
    key: [0xffd18a, 2.55, 2.2, 4.4, 3.3, false],
    fill: [0xffe2c5, 0.88, -1.8, 2.2, 3.1, false],
    rim: [0x52ff8d, 1.05, -3.3, 2.7, -3.4, false],
    point: [0x7c3cff, 0.18, -1.6, 1.4, 2.2],
    face: [0xffead2, 1.15, 0, 1.45, 4.2],
  },
  doctor: {
    background: 'doctor',
    fog: 0xdceff4,
    fogNear: 28,
    fogFar: 70,
    exposure: 1.04,
    cameraMultiplier: 1.58,
    minZoom: 0.74,
    maxZoom: 1.6,
    autoRotateSpeed: 0.0026,
    materialBoost: 1.04,
    particles: 'none',
    hemi: [0xffffff, 0xb9dce7, 1.85],
    key: [0xffffff, 2.35, 2.4, 4.5, 3.5],
    fill: [0xc7f3ff, 1.15, -2.8, 1.8, 2.6],
    rim: [0x7ad7e8, 1.15, -2.9, 2.4, -3.3],
    point: [0xffffff, 0.32, 0, 2.4, 2.6],
  },
  army: {
    background: 'army', fog: 0x11150c, fogNear: 20, fogFar: 50, exposure: 1.06,
    cameraMultiplier: 1.54, minZoom: 0.72, maxZoom: 1.58, autoRotateSpeed: 0.0027,
    materialBoost: 1.04, particles: 'none',
    hemi: [0xffedc8, 0x11170d, 1.5], key: [0xffd28a, 2.35, 2.6, 4.4, 3.3],
    fill: [0xb7c99d, 0.62, -2.8, 1.7, 2.5], rim: [0xd4b56a, 1.35, -3.0, 2.5, -3.2],
    point: [0xffc85f, 0.24, 0, 2.0, 2.6],
  },
  police: {
    background: 'police', fog: 0x07111c, fogNear: 20, fogFar: 52, exposure: 1.07,
    cameraMultiplier: 1.54, minZoom: 0.72, maxZoom: 1.58, autoRotateSpeed: 0.0027,
    materialBoost: 1.04, particles: 'none',
    hemi: [0xe7f2ff, 0x07101a, 1.45], key: [0xddeeff, 2.25, 2.5, 4.4, 3.4],
    fill: [0x5f95c9, 0.66, -2.7, 1.7, 2.5], rim: [0x7bbcff, 1.55, -3.0, 2.5, -3.2],
    point: [0xe8bd5d, 0.22, 0, 2.0, 2.6],
  },
  lawyer: {
    background: 'lawyer', fog: 0x17110b, fogNear: 22, fogFar: 54, exposure: 1.08,
    cameraMultiplier: 1.56, minZoom: 0.73, maxZoom: 1.58, autoRotateSpeed: 0.0025,
    materialBoost: 1.04, particles: 'none',
    hemi: [0xfff4df, 0x17110b, 1.58], key: [0xffe1a3, 2.35, 2.5, 4.5, 3.5],
    fill: [0xe6d7bd, 0.72, -2.7, 1.8, 2.5], rim: [0xd5a94f, 1.35, -3.0, 2.5, -3.2],
    point: [0xf2c45f, 0.25, 0, 2.1, 2.6],
  },
  firefighter: {
    background: 'firefighter', fog: 0x180905, fogNear: 18, fogFar: 48, exposure: 1.08,
    cameraMultiplier: 1.52, minZoom: 0.71, maxZoom: 1.56, autoRotateSpeed: 0.0028,
    materialBoost: 1.05, particles: 'none',
    hemi: [0xffe7c5, 0x170704, 1.48], key: [0xffc06a, 2.55, 2.6, 4.4, 3.3],
    fill: [0xd76c43, 0.58, -2.8, 1.6, 2.5], rim: [0xffd36f, 1.55, -3.0, 2.5, -3.2],
    point: [0xff7b32, 0.34, 0, 1.8, 2.6],
  },  'premium-default': {
    background: 'premium-default',
    fog: 0x100806,
    fogNear: 18,
    fogFar: 44,
    exposure: 1.08,
    cameraMultiplier: 1.5,
    minZoom: 0.7,
    maxZoom: 1.55,
    autoRotateSpeed: 0.003,
    materialBoost: 1.05,
    particles: 'none',
    hemi: [0xfff1d4, 0x120806, 1.5],
    key: [0xffd27a, 2.35, 2.6, 4.2, 3.4],
    fill: [0xffffff, 0.7, -2.5, 1.7, 2.2],
    rim: [0xf2c45f, 1.6, -2.8, 2.6, -3.2],
    point: [0xf2c45f, 0.28, 0, 1.8, 2.6],
  },
};

const getPresetConfig = (preset = 'premium-default') => {
  const key = String(preset).toLowerCase();
  return SCENE_CONFIGS[key] || SCENE_CONFIGS['premium-default'];
};

const fitCameraToObject = (THREE, camera, object, target, config, viewportAspect = 1) => {
  const box = new THREE.Box3().setFromObject(object);
  const size = box.getSize(new THREE.Vector3());
  const center = box.getCenter(new THREE.Vector3());
  const fov = (Math.PI * camera.fov) / 180;
  const fitHeightDistance = size.y / (2 * Math.tan(fov / 2));
  const fitWidthDistance = size.x / viewportAspect / (2 * Math.tan(fov / 2));
  const distance = Math.max(fitHeightDistance, fitWidthDistance, size.z || 1) * config.cameraMultiplier;

  object.position.sub(center);
  camera.position.set(0, size.y * 0.05, distance);
  camera.userData.baseDistance = distance;
  camera.userData.minDistance = distance * config.minZoom;
  camera.userData.maxDistance = distance * config.maxZoom;
  camera.near = Math.max(distance / 100, 0.01);
  camera.far = distance * 100;
  camera.updateProjectionMatrix();
  target.set(0, 0, 0);
};

const enhanceModelMaterials = (model, config) => {
  model.traverse((child) => {
    if (!child.isMesh || !child.material) return;

    child.castShadow = !config.disableModelShadows;
    child.receiveShadow = !config.disableModelShadows;

    const originalMaterial = child.material;
    const materials = Array.isArray(originalMaterial) ? originalMaterial : [originalMaterial];
    const enhancedMaterials = materials.map((material) => {
      const next = material.clone();
      if ('roughness' in next) next.roughness = clamp((next.roughness ?? 0.6) * 0.88, 0.25, 0.94);
      if ('metalness' in next) next.metalness = clamp(next.metalness ?? 0.05, 0, 0.18);
      if (next.color) next.color.multiplyScalar(config.materialBoost || 1.04);
      next.needsUpdate = true;
      return next;
    });

    child.material = Array.isArray(originalMaterial) ? enhancedMaterials : enhancedMaterials[0];
  });
};

const createViewerBackground = (THREE, config) => {
  const canvas = document.createElement('canvas');
  const size = 1024;
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');
  if (!ctx) return new THREE.Color(0x100806);

  const mode = config.background;
  const base = ctx.createLinearGradient(0, 0, size, size);

  if (mode === 'naruto-simple') {
    base.addColorStop(0, '#101b32');
    base.addColorStop(0.48, '#c96a1d');
    base.addColorStop(1, '#080604');
  } else if (mode === 'naruto-action') {
    base.addColorStop(0, '#06152d');
    base.addColorStop(0.42, '#e06b18');
    base.addColorStop(0.72, '#281006');
    base.addColorStop(1, '#050303');
  } else if (mode === 'sasuke-action') {
    base.addColorStop(0, '#03040b');
    base.addColorStop(0.46, '#14122b');
    base.addColorStop(0.76, '#26153b');
    base.addColorStop(1, '#020205');
  } else if (mode === 'madara') {
    base.addColorStop(0, '#d9c2b8');
    base.addColorStop(0.42, '#8d5355');
    base.addColorStop(0.78, '#33202b');
    base.addColorStop(1, '#120b0d');
  } else if (mode === 'luffy') {
    base.addColorStop(0, '#d7eef7');
    base.addColorStop(0.44, '#78b7d3');
    base.addColorStop(0.76, '#f0b34f');
    base.addColorStop(1, '#2e2a22');
  } else if (mode === 'nagato-pain') {
    base.addColorStop(0, '#d8d0e6');
    base.addColorStop(0.44, '#756b91');
    base.addColorStop(0.76, '#3a2f47');
    base.addColorStop(1, '#110d18');
  } else if (mode === 'obito') {
    base.addColorStop(0, '#dfc8bc');
    base.addColorStop(0.44, '#8d5640');
    base.addColorStop(0.76, '#40304f');
    base.addColorStop(1, '#110b0e');
  } else if (mode === 'premanand-maharaj') {
    base.addColorStop(0, '#fff1d0');
    base.addColorStop(0.46, '#e7b969');
    base.addColorStop(0.76, '#8c6020');
    base.addColorStop(1, '#261508');
  } else if (mode === 'gojo') {
    base.addColorStop(0, '#f1f7fa');
    base.addColorStop(0.46, '#b9d6e4');
    base.addColorStop(0.78, '#7d96a8');
    base.addColorStop(1, '#26313d');
  } else if (mode === 'kakashi') {
    base.addColorStop(0, '#edf3f1');
    base.addColorStop(0.46, '#c4d7d0');
    base.addColorStop(0.78, '#788c86');
    base.addColorStop(1, '#26302d');
  } else if (mode === 'joker') {
    base.addColorStop(0, '#050205');
    base.addColorStop(0.44, '#160817');
    base.addColorStop(0.72, '#241006');
    base.addColorStop(1, '#030202');
  } else if (mode === 'doctor') {
    base.addColorStop(0, '#d9f4f8');
    base.addColorStop(0.42, '#8fcfdc');
    base.addColorStop(0.72, '#17252b');
    base.addColorStop(1, '#050706');
  } else if (mode === 'army') {
    base.addColorStop(0, '#28331e'); base.addColorStop(0.5, '#171d11'); base.addColorStop(1, '#050604');
  } else if (mode === 'police') {
    base.addColorStop(0, '#18314a'); base.addColorStop(0.5, '#0a1928'); base.addColorStop(1, '#030507');
  } else if (mode === 'lawyer') {
    base.addColorStop(0, '#3a2a18'); base.addColorStop(0.48, '#18110b'); base.addColorStop(1, '#050403');
  } else if (mode === 'firefighter') {
    base.addColorStop(0, '#45170b'); base.addColorStop(0.46, '#201008'); base.addColorStop(1, '#050302');
  } else {
    base.addColorStop(0, '#110b06');
    base.addColorStop(0.44, '#211407');
    base.addColorStop(1, '#050403');
  }

  ctx.fillStyle = base;
  ctx.fillRect(0, 0, size, size);

  const glow = ctx.createRadialGradient(size * 0.52, size * 0.36, 20, size * 0.52, size * 0.36, size * 0.62);
  if (mode === 'naruto-action') {
    glow.addColorStop(0, 'rgba(255, 158, 38, 0.62)');
    glow.addColorStop(0.3, 'rgba(49, 139, 255, 0.24)');
  } else if (mode === 'naruto-simple') {
    glow.addColorStop(0, 'rgba(255, 183, 78, 0.42)');
    glow.addColorStop(0.34, 'rgba(92, 161, 255, 0.18)');
  } else if (mode === 'sasuke-action') {
    glow.addColorStop(0, 'rgba(118, 101, 255, 0.46)');
    glow.addColorStop(0.34, 'rgba(73, 29, 126, 0.32)');
  } else if (mode === 'madara') {
    glow.addColorStop(0, 'rgba(255, 217, 180, 0.34)');
    glow.addColorStop(0.34, 'rgba(184, 61, 72, 0.18)');
  } else if (mode === 'luffy') {
    glow.addColorStop(0, 'rgba(255, 231, 150, 0.42)');
    glow.addColorStop(0.34, 'rgba(131, 211, 255, 0.26)');
  } else if (mode === 'nagato-pain') {
    glow.addColorStop(0, 'rgba(230, 216, 255, 0.32)');
    glow.addColorStop(0.34, 'rgba(157, 89, 255, 0.18)');
  } else if (mode === 'obito') {
    glow.addColorStop(0, 'rgba(255, 196, 140, 0.32)');
    glow.addColorStop(0.34, 'rgba(132, 103, 214, 0.18)');
  } else if (mode === 'premanand-maharaj') {
    glow.addColorStop(0, 'rgba(255, 244, 206, 0.46)');
    glow.addColorStop(0.34, 'rgba(219, 158, 74, 0.22)');
  } else if (mode === 'gojo') {
    glow.addColorStop(0, 'rgba(255, 255, 255, 0.5)');
    glow.addColorStop(0.34, 'rgba(142, 210, 255, 0.24)');
  } else if (mode === 'kakashi') {
    glow.addColorStop(0, 'rgba(255, 255, 255, 0.46)');
    glow.addColorStop(0.34, 'rgba(139, 189, 171, 0.22)');
  } else if (mode === 'joker') {
    glow.addColorStop(0, 'rgba(103, 255, 144, 0.22)');
    glow.addColorStop(0.28, 'rgba(143, 77, 255, 0.28)');
  } else if (mode === 'doctor') {
    glow.addColorStop(0, 'rgba(255, 255, 255, 0.48)');
    glow.addColorStop(0.32, 'rgba(111, 218, 232, 0.28)');
  } else if (mode === 'army') {
    glow.addColorStop(0, 'rgba(218, 190, 119, 0.3)'); glow.addColorStop(0.32, 'rgba(100, 124, 76, 0.2)');
  } else if (mode === 'police') {
    glow.addColorStop(0, 'rgba(211, 235, 255, 0.34)'); glow.addColorStop(0.32, 'rgba(69, 137, 199, 0.2)');
  } else if (mode === 'lawyer') {
    glow.addColorStop(0, 'rgba(255, 226, 166, 0.38)'); glow.addColorStop(0.32, 'rgba(151, 103, 44, 0.18)');
  } else if (mode === 'firefighter') {
    glow.addColorStop(0, 'rgba(255, 190, 94, 0.38)'); glow.addColorStop(0.32, 'rgba(181, 63, 25, 0.2)');
  } else {
    glow.addColorStop(0, 'rgba(248, 198, 89, 0.36)');
    glow.addColorStop(0.32, 'rgba(96, 62, 22, 0.22)');
  }
  glow.addColorStop(0.58, 'rgba(30, 18, 10, 0.14)');
  glow.addColorStop(1, 'rgba(0, 0, 0, 0)');
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, size, size);

  ctx.save();
  ctx.translate(size * 0.5, size * 0.44);

  if (mode === 'naruto-simple' || mode === 'naruto-action') {
    ctx.strokeStyle = mode === 'naruto-action' ? 'rgba(255, 166, 49, 0.24)' : 'rgba(248, 198, 89, 0.16)';
    ctx.lineWidth = mode === 'naruto-action' ? 5 : 3;
    for (let i = 0; i < 5; i += 1) {
      ctx.beginPath();
      ctx.arc(0, 0, 130 + i * 58, Math.PI * (0.16 + i * 0.08), Math.PI * (1.72 + i * 0.09));
      ctx.stroke();
    }

    if (mode === 'naruto-action') {
      ctx.strokeStyle = 'rgba(255, 114, 26, 0.18)';
      ctx.lineWidth = 3;
      for (let i = 0; i < 10; i += 1) {
        ctx.rotate(Math.PI / 5);
        ctx.beginPath();
        ctx.moveTo(76, 0);
        ctx.lineTo(430, 0);
        ctx.stroke();
      }
    }
  } else if (mode === 'sasuke-action' || mode === 'nagato-pain') {
    ctx.strokeStyle = 'rgba(137, 116, 255, 0.2)';
    ctx.lineWidth = 2;
    for (let i = 0; i < 7; i += 1) {
      const y = -310 + i * 96;
      ctx.beginPath();
      ctx.moveTo(-430, y);
      ctx.bezierCurveTo(-120, y - 80, 130, y + 70, 430, y - 40);
      ctx.stroke();
    }
    ctx.strokeStyle = 'rgba(94, 177, 255, 0.16)';
    for (let i = 0; i < 8; i += 1) {
      ctx.beginPath();
      const x = -360 + i * 105;
      ctx.moveTo(x, -240);
      ctx.lineTo(x + 42, -172);
      ctx.lineTo(x + 10, -104);
      ctx.stroke();
    }
  } else if (mode === 'madara') {
    ctx.strokeStyle = 'rgba(213, 35, 48, 0.16)';
    ctx.lineWidth = 4;
    for (let i = 0; i < 8; i += 1) {
      ctx.rotate(Math.PI / 4);
      ctx.beginPath();
      ctx.moveTo(74, 0);
      ctx.lineTo(410, 0);
      ctx.stroke();
    }
    ctx.strokeStyle = 'rgba(120, 83, 214, 0.12)';
    ctx.lineWidth = 2;
    for (let i = 0; i < 4; i += 1) {
      ctx.beginPath();
      ctx.arc(0, 0, 140 + i * 74, Math.PI * 0.05, Math.PI * 1.62);
      ctx.stroke();
    }
  } else if (mode === 'luffy') {
    ctx.strokeStyle = 'rgba(133, 217, 255, 0.14)';
    ctx.lineWidth = 3;
    for (let i = 0; i < 6; i += 1) {
      const y = -260 + i * 96;
      ctx.beginPath();
      ctx.moveTo(-430, y);
      ctx.bezierCurveTo(-180, y + 54, 120, y - 54, 430, y + 20);
      ctx.stroke();
    }
    ctx.strokeStyle = 'rgba(255, 210, 94, 0.16)';
    ctx.lineWidth = 2;
    for (let i = 0; i < 9; i += 1) {
      ctx.rotate(Math.PI / 9);
      ctx.beginPath();
      ctx.moveTo(58, -58);
      ctx.lineTo(340, -58);
      ctx.stroke();
    }
  } else if (mode === 'obito') {
    ctx.strokeStyle = 'rgba(255, 116, 49, 0.18)';
    ctx.lineWidth = 3;
    for (let i = 0; i < 8; i += 1) {
      ctx.beginPath();
      ctx.arc(0, 0, 90 + i * 46, Math.PI * (0.05 + i * 0.04), Math.PI * (1.1 + i * 0.1));
      ctx.stroke();
      ctx.rotate(Math.PI / 7);
    }
  } else if (mode === 'premanand-maharaj') {
    ctx.strokeStyle = 'rgba(255, 222, 145, 0.16)';
    ctx.lineWidth = 2;
    for (let i = 0; i < 5; i += 1) {
      ctx.beginPath();
      ctx.arc(0, 0, 110 + i * 64, 0, Math.PI * 2);
      ctx.stroke();
    }
    ctx.fillStyle = 'rgba(255, 229, 164, 0.08)';
    ctx.fillRect(-360, -280, 720, 88);
    ctx.fillRect(-360, 210, 720, 70);
  } else if (mode === 'gojo') {
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.28)';
    ctx.lineWidth = 3;
    for (let i = 0; i < 6; i += 1) {
      const y = -280 + i * 110;
      ctx.beginPath();
      ctx.moveTo(-420, y);
      ctx.bezierCurveTo(-120, y - 44, 150, y + 56, 420, y - 10);
      ctx.stroke();
    }
    ctx.fillStyle = 'rgba(154, 215, 255, 0.1)';
    ctx.fillRect(-370, -280, 180, 520);
  } else if (mode === 'kakashi') {
    ctx.strokeStyle = 'rgba(130, 177, 163, 0.2)';
    ctx.lineWidth = 2;
    for (let i = 0; i < 6; i += 1) {
      const y = -280 + i * 105;
      ctx.beginPath();
      ctx.moveTo(-420, y);
      ctx.lineTo(420, y - 36);
      ctx.stroke();
    }
    ctx.fillStyle = 'rgba(255, 255, 255, 0.1)';
    ctx.fillRect(160, -300, 190, 520);
  } else if (mode === 'joker') {
    const spotlight = ctx.createRadialGradient(0, -90, 12, 0, -90, 470);
    spotlight.addColorStop(0, 'rgba(255, 211, 116, 0.26)');
    spotlight.addColorStop(0.38, 'rgba(129, 60, 174, 0.14)');
    spotlight.addColorStop(1, 'rgba(0, 0, 0, 0)');
    ctx.fillStyle = spotlight;
    ctx.fillRect(-size / 2, -size / 2, size, size);

    ctx.strokeStyle = 'rgba(89, 255, 135, 0.12)';
    ctx.lineWidth = 4;
    ctx.beginPath();
    ctx.moveTo(-420, -210);
    ctx.bezierCurveTo(-130, -40, 150, -320, 420, -80);
    ctx.stroke();
    ctx.strokeStyle = 'rgba(157, 89, 255, 0.12)';
    ctx.beginPath();
    ctx.moveTo(-430, 190);
    ctx.bezierCurveTo(-90, 20, 160, 260, 430, 80);
    ctx.stroke();
  } else if (mode === 'doctor') {
    ctx.strokeStyle = 'rgba(210, 250, 255, 0.18)';
    ctx.lineWidth = 2;
    for (let i = 0; i < 6; i += 1) {
      const y = -260 + i * 100;
      ctx.beginPath();
      ctx.moveTo(-420, y);
      ctx.lineTo(420, y - 34);
      ctx.stroke();
    }
    ctx.fillStyle = 'rgba(255, 255, 255, 0.08)';
    ctx.fillRect(-390, -300, 210, 520);
    ctx.fillStyle = 'rgba(100, 220, 230, 0.08)';
    ctx.fillRect(190, -240, 160, 440);
  } else {
    ctx.strokeStyle = 'rgba(248, 198, 89, 0.12)';
    ctx.lineWidth = 2;
    for (let i = 0; i < 5; i += 1) {
      const y = -260 + i * 120;
      ctx.beginPath();
      ctx.moveTo(-420, y);
      ctx.lineTo(420, y - 70);
      ctx.stroke();
    }
  }

  ctx.restore();

  const vignette = ctx.createRadialGradient(size * 0.5, size * 0.44, size * 0.2, size * 0.5, size * 0.44, size * 0.76);
  vignette.addColorStop(0, 'rgba(0, 0, 0, 0)');
  const usesLightStudio = ['doctor', 'lawyer', 'luffy', 'premanand-maharaj', 'gojo', 'kakashi'].includes(mode);
  const usesBalancedStudio = ['madara', 'nagato-pain', 'obito'].includes(mode);
  vignette.addColorStop(0.62, usesLightStudio ? 'rgba(0, 0, 0, 0.08)' : usesBalancedStudio ? 'rgba(0, 0, 0, 0.16)' : 'rgba(0, 0, 0, 0.28)');
  vignette.addColorStop(1, usesLightStudio ? 'rgba(0, 0, 0, 0.28)' : usesBalancedStudio ? 'rgba(0, 0, 0, 0.46)' : 'rgba(0, 0, 0, 0.78)');
  ctx.fillStyle = vignette;
  ctx.fillRect(0, 0, size, size);

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.needsUpdate = true;
  return texture;
};

const addDirectionalLight = (THREE, scene, lightConfig) => {
  const [color, intensity, x, y, z, castShadowOverride] = lightConfig;
  const light = new THREE.DirectionalLight(color, intensity);
  light.position.set(x, y, z);
  light.castShadow = castShadowOverride ?? intensity > 2;
  if (light.castShadow) light.shadow.mapSize.set(1024, 1024);
  scene.add(light);
  return light;
};

const addPointLight = (THREE, scene, lightConfig) => {
  if (!lightConfig) return;
  const [color, intensity, x, y, z] = lightConfig;
  const light = new THREE.PointLight(color, intensity, 7, 2);
  light.position.set(x, y, z);
  scene.add(light);
};

const addSceneParticles = (THREE, scene, config) => {
  if (config.particles === 'none') return null;

  const count = config.particles === 'energy-streaks' ? 70 : 46;
  const positions = new Float32Array(count * 3);
  const colors = new Float32Array(count * 3);
  const color = new THREE.Color();

  for (let i = 0; i < count; i += 1) {
    const radius = 1.4 + Math.random() * 3.2;
    const angle = Math.random() * Math.PI * 2;
    positions[i * 3] = Math.cos(angle) * radius;
    positions[i * 3 + 1] = -1.1 + Math.random() * 3.6;
    positions[i * 3 + 2] = Math.sin(angle) * radius - 1.2;

    if (config.particles === 'electric-glow') color.setHex(Math.random() > 0.5 ? 0x866cff : 0x7db7ff);
    else if (config.particles === 'neon-dust') color.setHex(Math.random() > 0.5 ? 0x6dff9a : 0x9b62ff);
    else if (config.particles === 'energy-streaks') color.setHex(Math.random() > 0.45 ? 0xff8a1f : 0x62a9ff);
    else color.setHex(0xf2c45f);

    colors[i * 3] = color.r;
    colors[i * 3 + 1] = color.g;
    colors[i * 3 + 2] = color.b;
  }

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

  const material = new THREE.PointsMaterial({
    size: config.particles === 'energy-streaks' ? 0.035 : 0.028,
    vertexColors: true,
    transparent: true,
    opacity: 0.55,
    depthWrite: false,
  });

  const points = new THREE.Points(geometry, material);
  scene.add(points);
  return points;
};

const initViewer = async (root) => {
  if (initialized.has(root)) return;
  initialized.add(root);

  const mount = root.querySelector('[data-mw-three-canvas]');
  const fullscreenButton = root.querySelector('[data-mw-three-fullscreen]');
  const loading = root.querySelector('[data-mw-three-loading]');
  const loadingText = loading?.querySelector('.mw-three-viewer__loading-text');
  const modelUrl = root.dataset.modelUrl;
  const viewerPreset = root.dataset.viewerPreset || 'premium-default';
  const config = getPresetConfig(viewerPreset);
  const threeUrl = root.dataset.threeUrl;
  const gltfLoaderUrl = root.dataset.gltfLoaderUrl;
  const dracoLoaderUrl =
    root.dataset.dracoLoaderUrl || 'https://esm.sh/three@0.160.1/examples/jsm/loaders/DRACOLoader.js';
  const dracoDecoderPath =
    root.dataset.dracoDecoderPath || 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/';
  if (!mount || !modelUrl || !threeUrl || !gltfLoaderUrl) return;

  const setLoadingText = (message) => {
    if (loadingText) loadingText.textContent = message;
  };

  const hideLoading = () => {
    if (loading) loading.classList.add('is-hidden');
  };

  let THREE;
  let GLTFLoader;
  let DRACOLoader;

  try {
    setLoadingText('Preparing 3D model...');
    const [threeModule, loaderModule, dracoModule] = await Promise.all([
      import(threeUrl),
      import(gltfLoaderUrl),
      import(dracoLoaderUrl),
    ]);
    THREE = threeModule;
    GLTFLoader = loaderModule.GLTFLoader;
    DRACOLoader = dracoModule.DRACOLoader;
  } catch (error) {
    console.error('MiniatureWallah Three.js viewer could not load dependencies.', error);
    setLoadingText('3D viewer could not load. Please refresh or try again later.');
    return;
  }

  const scene = new THREE.Scene();
  scene.background = createViewerBackground(THREE, config);
  scene.fog = new THREE.Fog(config.fog, config.fogNear, config.fogFar);

  const camera = new THREE.PerspectiveCamera(34, 1, 0.01, 1000);
  const target = new THREE.Vector3();

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false, powerPreference: 'high-performance' });
  const pixelRatioCap = window.matchMedia('(max-width: 749px)').matches ? 1.25 : 1.75;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, pixelRatioCap));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = config.exposure;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  mount.appendChild(renderer.domElement);

  const stage = new THREE.Group();
  scene.add(stage);

  scene.add(new THREE.HemisphereLight(...config.hemi));
  addDirectionalLight(THREE, scene, config.key);
  addDirectionalLight(THREE, scene, config.fill);
  addDirectionalLight(THREE, scene, config.rim);
  addPointLight(THREE, scene, config.point);
  addPointLight(THREE, scene, config.face);
  const particles = addSceneParticles(THREE, scene, config);

  const loader = new GLTFLoader();
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath(dracoDecoderPath);
  loader.setDRACOLoader(dracoLoader);
  let model;

  try {
    setLoadingText('Loading 3D model. This may take a moment on slower internet.');
    const gltf = await loader.loadAsync(modelUrl, (event) => {
      if (!event.lengthComputable) return;
      const progress = Math.min(99, Math.round((event.loaded / event.total) * 100));
      setLoadingText(`Loading 3D model... ${progress}%`);
    });
    model = gltf.scene;
    enhanceModelMaterials(model, config);
    stage.add(model);
    hideLoading();
    dracoLoader.dispose();
  } catch (error) {
    console.error('MiniatureWallah 3D model could not load.', error);
    setLoadingText('3D model could not load. Please refresh or try again later.');
    dracoLoader.dispose();
    return;
  }

  let isDragging = false;
  let previousX = 0;
  let previousY = 0;
  let autoRotate = true;
  let stagePitch = -0.04;
  const activePointers = new Map();
  let previousPinchDistance = 0;

  const resize = () => {
    const rect = mount.getBoundingClientRect();
    const width = Math.max(1, rect.width);
    const height = Math.max(1, rect.height || rect.width);
    renderer.setSize(width, height, false);
    camera.aspect = width / height;
    fitCameraToObject(THREE, camera, stage, target, config, camera.aspect);
    camera.lookAt(target);
  };

  root.style.touchAction = 'none';
  mount.style.touchAction = 'none';
  mount.style.userSelect = 'none';

  const clampZoom = (nextZ) => clamp(nextZ, camera.userData.minDistance || 0.5, camera.userData.maxDistance || 8);

  const getPinchDistance = () => {
    const pointers = [...activePointers.values()];
    if (pointers.length < 2) return 0;
    return Math.hypot(pointers[0].x - pointers[1].x, pointers[0].y - pointers[1].y);
  };

  const onPointerDown = (event) => {
    event.preventDefault();
    activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    autoRotate = false;
    mount.setPointerCapture?.(event.pointerId);

    if (activePointers.size >= 2) {
      isDragging = false;
      previousPinchDistance = getPinchDistance();
      return;
    }

    isDragging = true;
    previousX = event.clientX;
    previousY = event.clientY;
  };

  const onPointerMove = (event) => {
    if (!activePointers.has(event.pointerId)) return;
    event.preventDefault();
    activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

    if (activePointers.size >= 2) {
      const nextPinchDistance = getPinchDistance();
      if (previousPinchDistance > 0 && nextPinchDistance > 0) {
        camera.position.z = clampZoom(camera.position.z * (previousPinchDistance / nextPinchDistance));
      }
      previousPinchDistance = nextPinchDistance;
      return;
    }

    if (!isDragging) return;
    const deltaX = event.clientX - previousX;
    const deltaY = event.clientY - previousY;
    previousX = event.clientX;
    previousY = event.clientY;
    stage.rotation.y += deltaX * 0.008;
    stagePitch = clamp(stagePitch + deltaY * 0.004, -0.42, 0.28);
    stage.rotation.x = stagePitch;
  };

  const onPointerUp = (event) => {
    activePointers.delete(event.pointerId);
    mount.releasePointerCapture?.(event.pointerId);
    previousPinchDistance = activePointers.size >= 2 ? getPinchDistance() : 0;

    if (activePointers.size === 1) {
      const remainingPointer = [...activePointers.values()][0];
      isDragging = true;
      previousX = remainingPointer.x;
      previousY = remainingPointer.y;
      return;
    }

    isDragging = false;
  };

  mount.addEventListener('pointerdown', onPointerDown);
  mount.addEventListener('pointermove', onPointerMove);
  mount.addEventListener('pointerup', onPointerUp);
  mount.addEventListener('pointercancel', onPointerUp);
  mount.addEventListener('wheel', (event) => {
    event.preventDefault();
    camera.position.z = clampZoom(camera.position.z * (event.deltaY > 0 ? 1.08 : 0.92));
  }, { passive: false });

  const toggleFullscreen = async () => {
    try {
      if (document.fullscreenElement === root) {
        await document.exitFullscreen();
      } else if (root.requestFullscreen) {
        await root.requestFullscreen();
      }
      window.setTimeout(resize, 80);
    } catch (error) {
      console.error('Fullscreen mode could not be opened.', error);
    }
  };

  fullscreenButton?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleFullscreen();
  });

  document.addEventListener('fullscreenchange', () => {
    const isFullscreen = document.fullscreenElement === root;
    fullscreenButton?.setAttribute('aria-label', isFullscreen ? 'Exit fullscreen 3D model' : 'View 3D model fullscreen');
    fullscreenButton?.setAttribute('title', isFullscreen ? 'Exit fullscreen' : 'View fullscreen');
    fullscreenButton?.toggleAttribute('data-fullscreen-active', isFullscreen);
    window.setTimeout(resize, 80);
  });

  const observer = new ResizeObserver(resize);
  observer.observe(mount);
  resize();

  let animationFrame = 0;
  let isViewerVisible = false;
  let isPageScrolling = false;
  let scrollResumeTimer = 0;

  const animate = () => {
    if (!isViewerVisible || isPageScrolling || document.hidden) {
      animationFrame = 0;
      return;
    }

    if (autoRotate) stage.rotation.y += config.autoRotateSpeed;
    if (particles) particles.rotation.y -= config.autoRotateSpeed * 0.35;
    camera.lookAt(target);
    renderer.render(scene, camera);
    animationFrame = requestAnimationFrame(animate);
  };

  const startRendering = () => {
    if (animationFrame || !isViewerVisible || isPageScrolling || document.hidden) return;
    animationFrame = requestAnimationFrame(animate);
  };

  const stopRendering = () => {
    if (!animationFrame) return;
    cancelAnimationFrame(animationFrame);
    animationFrame = 0;
  };

  const handlePageScroll = () => {
    isPageScrolling = true;
    stopRendering();
    window.clearTimeout(scrollResumeTimer);
    scrollResumeTimer = window.setTimeout(() => {
      isPageScrolling = false;
      startRendering();
    }, 120);
  };

  window.addEventListener('scroll', handlePageScroll, { passive: true });
  const visibilityObserver = new IntersectionObserver(
    ([entry]) => {
      isViewerVisible = entry.isIntersecting;
      if (isViewerVisible) {
        resize();
        startRendering();
      } else {
        stopRendering();
      }
    },
    { rootMargin: '160px 0px', threshold: 0.01 }
  );

  visibilityObserver.observe(root);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopRendering();
    else startRendering();
  });
};

const initAll = () => {
  const roots = document.querySelectorAll('[data-mw-three-viewer]');

  if (!('IntersectionObserver' in window)) {
    roots.forEach(initViewer);
    return;
  }

  const loadObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        initViewer(entry.target);
      });
    },
    { rootMargin: '320px 0px', threshold: 0.01 }
  );

  roots.forEach((root) => loadObserver.observe(root));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll, { once: true });
} else {
  initAll();
}
